
export function useDescription() {
  const descriptionGlobal = [
    'Showing current Fertilizer Prices vs. last year',
    'Source: USDA AL, USDA IA, World Bank',
  ];
  return descriptionGlobal;
}